import englishMessages from '../constants/translations-en-us';
import hindiMessages from '../constants/translations-hi-in';

const getStringsForLocal = ({ locale }) => {
  switch (locale) {
    case 'en-US':
      return englishMessages;
    case 'hi-IN':
      return hindiMessages;

    default:
      return englishMessages;
  }
};

export default getStringsForLocal;
